import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import { RoutePermissions, RouteScreens } from "../../common/RoutePermissions";
import RouteConstants from "../../common/RouteConstants";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import AllInboxIcon from "@mui/icons-material/AllInbox";
import TimelineSharpIcon from "@mui/icons-material/TimelineSharp";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import GroupIcon from "@mui/icons-material/Group";

const useStyles = makeStyles((theme) => ({
  navigationLinkContainer: {
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
    "& > div": {
      [theme.breakpoints.down("sm")]: {
        width: "100%",
        display: "flex",
        flex: "1",
      },
    },
  },
  navigationLink: {
    color: "#1d428a",
    cursor: "pointer",
    background: "#fff",
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(1),
    padding: theme.spacing(0, 0, 0, 2),
    "& .MuiButton-endIcon": {
      position: "relative",
      background: "#1d428a",
      padding: theme.spacing(2, 2, 2, 3), //'15px 16px 15px 24px',
      color: "#fff",
      display: "inline-flex",
      verticalAlign: "middle",
      alignItems: "center",
      borderRadius: theme.spacing(0, 0.5, 0.5, 0), //'0px 4px 4px 0px',
      "&::before": {
        content: '""',
        position: "absolute",
        border: "none",
        borderLeft: "20px solid #ffffff",
        left: "-1px",
        zIndex: "1",
        top: "0",
        width: "0",
        borderBottom: "52px solid transparent",
        height: "0",
      },
    },
    "&:hover": { backgroundColor: "#fff" },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      flex: "1",
      justifyContent: "flex-start",
    },
    "& .MuiTypography-root": {
      [theme.breakpoints.down("sm")]: {
        display: "flex",
        flex: "1",
      },
    },
  },
}));

const AppNaviGator = ({ userAppRoles, user, eventId }) => {
  let navigate = useNavigate();
  const classes = useStyles();

  return (
    <Box style={{ width: "100%" }} mb={2}>
      <Box
        display="flex"
        alignItems="center"
        flex="1"
        justifyContent={
          userAppRoles.indexOf("Admin") !== -1 ? "space-between" : "normal"
        }
        flexWrap="wrap"
        className={classes.navigationLinkContainer}
      >
        {RoutePermissions.IsAuthorized(
          RouteScreens.TeamBallotDashboard,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.TEAM_BALLOT_DASHBOARD)}
              variant="contained"
              underline="none"
              endIcon={<DashboardIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              {" "}
              Combine Team Ballot{" "}
            </Button>
          </Box>
        ) : (
          ""
        )}
        {RoutePermissions.IsAuthorized(
          RouteScreens.TeamGreenBallotVote,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.TEAM_GREEN_BALLOT_VOTE)}
              variant="contained"
              underline="none"
              endIcon={<DashboardIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Green Room Ballot</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}

        {RoutePermissions.IsAuthorized(
          RouteScreens.TeamGLeagueBallot,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.TEAM_TOP_FIVE_BALLOT_VOTE)}
              variant="contained"
              underline="none"
              endIcon={<DashboardIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">GLeague Ballot</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}

        {RoutePermissions.IsAuthorized(
          RouteScreens.AdminBallotDashboard,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.ADMIN_BALLOT_DASHBOARD)}
              variant="contained"
              underline="none"
              endIcon={<DashboardIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">
                Admin Ballot Dashboard
              </Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}
        {RoutePermissions.IsAuthorized(
          RouteScreens.AdminPreferences,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.ADMIN_PREFERENCES)}
              variant="contained"
              underline="none"
              endIcon={<AdminPanelSettingsIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Admin Preferences </Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}
        {user.isAdmin ||
        (RoutePermissions.IsAuthorized(
          RouteScreens.ViewPlayerProfile,
          userAppRoles
        ) &&
          user.playerProfileFlag) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() =>
                navigate(`/${eventId}${RouteConstants.PLAYER_LIST}`)
              }
              variant="contained"
              underline="none"
              endIcon={<PersonOutlineIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Player Profile</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}
        {user.isAdmin ||
        (RoutePermissions.IsAuthorized(
          RouteScreens.CombineResults,
          userAppRoles
        ) &&
          user.combineResultsFlag) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() =>
                navigate(`${eventId}${RouteConstants.COMBINE_RESULTS}`)
              }
              variant="contained"
              underline="none"
              endIcon={<DashboardIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Combine Results</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}

        {/* Box Score Container */}
        {RoutePermissions.IsAuthorized(RouteScreens.BoxScore, userAppRoles) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.BOX_SCORE)}
              variant="contained"
              underline="none"
              endIcon={<AllInboxIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Box Score</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}

        {user.isAdmin ||
        RoutePermissions.IsAuthorized(
          RouteScreens.CareerStatsDashboard,
          userAppRoles
        ) /* &&
        user.playerProfileFlag*/ ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() =>
                navigate(`/${eventId}${RouteConstants.CAREER_STATS}`)
              }
              variant="contained"
              underline="none"
              endIcon={<TimelineSharpIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Comparables</Typography>
            </Button>
          </Box>
        ) : (
          ""
        )}

        {user.isCompleteTeamUser && user.isDisplayTeamRosterFlag ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.VIEW_TEAM_ROSTER)}
              variant="contained"
              underline="none"
              endIcon={<GroupIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Team Rosters</Typography>
            </Button>
          </Box>
        ) : null}

        {RoutePermissions.IsAuthorized(
          RouteScreens.EventCalendar,
          userAppRoles
        ) ? (
          <Box mr={userAppRoles.indexOf("Admin") !== -1 ? 0 : 5}>
            <Button
              className={classes.navigationLink}
              onClick={() => navigate(RouteConstants.EVENT_SCHEDULER)}
              variant="contained"
              underline="none"
              endIcon={<CalendarMonthIcon />}
              style={{ display: "flex", alignItems: "center" }}
            >
              <Typography variant="subtitle2">Event Calendar</Typography>
            </Button>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default AppNaviGator;
